/*jshint esversion: 6*/
export const appId = '2882303761517406076';
export const token = '5471740665076';
export const shareAppId = '2882303761517406118';
export const shareToken = '5531740676118';
export const browserEnterToken = '5261740590954';
export const browserEnterAppId = '2882303761517405954';
export const browserShareAppId = '2882303761517406154';
export const browserShareToken = '5791740648154';
export const browserSimpleAppId = '2882303761517406156';
export const browserSimpleToken = '5371740610156';
export const statsUrl = 'https://o2o.api.xiaomi.com/tracker';
export const scheme = 'bikan://web.goto/';
export const appStore = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.xiangkan.android&ckey=CK1430771235862';
export const miAppStore = 'http://app.mi.com/details?id=com.xiangkan.android';
export const imeiMd5Key = 'newsImeiMd5';
export const browserDownloadUrl = 'https://hd.xiangkannews.cn/hd20190801/#page=read';
export const shareTextArr = [
    '有2000万朋友，在想看资讯',
    '您的好友在想看 邀您一起',
    '90%的网友都在热议！'
];
export const browserTrackCategory = [
    {name: '文章详情页相关推荐', code: 'third'},
    {name: '推荐', code: 'rec'},
    {name: '两会', code: 'sessions'},
    {name: '视频', code: 'videos'},
    {name: '本地', code: 'location'},
    {name: '要闻', code: 'topnews'},
    {name: '娱乐', code: 'entertainment'},
    {name: '小说', code: 'novels'},
    {name: '军事', code: 'military'},
    {name: '体育', code: 'sport'},
    {name: '财经', code: 'finance'},
    {name: '科技', code: 'science'},
    {name: '汽车', code: 'car'},
    {name: '搞笑', code: 'jokes'},
    {name: '美女', code: 'beauties'},
    {name: '好物', code: 'shopping'},
    {name: '游戏', code: 'game'},
    {name: '房产', code: 'property'},
    {name: '教育', code: 'education'},
    {name: '社会', code: 'society'},
    {name: '时政', code: 'currentPolitics'},
    {name: '国际', code: 'international'},
    {name: '文化', code: 'culture'},
    {name: '历史', code: 'history'},
    {name: '家居', code: 'household'},
    {name: '旅行', code: 'tourism'},
    {name: '美食', code: 'food'},
    {name: '时尚', code: 'fashion'},
    {name: '育儿', code: 'parenting'},
    {name: '健康', code: 'health'},
    {name: '星座', code: 'constellations'},
    {name: '情感', code: 'emotion'},
];
